/* eslint-disable  */
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./ApplyLoans.css";
import Loan_chip from "./components/Loan_chip";

const inputCls = "mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent";
const readonlyCls = "mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-sm cursor-not-allowed";

const Field = ({ label, required, error, children }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">
      {label}{required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
  </div>
);

function Employment() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    SubmitUpdateLoanFormOne,
    ResetUserDataResponse,
    GetFormOneAppliedLoanTemp,
  } = bindActionCreators(userDataActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);

  const [formState] = useState(3);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState({});

  const response = useSelector((state) => state?.user?.response);
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const user = useSelector((state) => state?.auth?.user);
  const userData = useSelector((state) => state?.user);
  const { loanTemp } = userData;

  const employer_name = user?.facility?.split(" ")[1]?.split(":")[0];

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    GetUserProfile();
    GetFormOneAppliedLoanTemp();
  }, []);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      staff_id: user?.staff_id,
      facility: user?.facility,
      employer_name,
      employment_start_date: loanTemp?.employment_start_date,
    }));
  }, [loanTemp, user]);

  const handleFormChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const err = {};
    if (!formData.employment_start_date) err.employment_start_date = "Employment start date is required";
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  const handleFormSubmitHandler = (e) => {
    e.preventDefault();
    if (validateForm()) {
      SubmitUpdateLoanFormOne({ ...loanTemp, ...formData }, loanTemp?._id);
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      ResetUserDataResponse();
      history.push("/apply-loan-loan_detailed");
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "DELETED") {
      toast.success(response?.message);
      history.push("/apply-loan-personal_info");
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state, response?.message, response?.action]);

  return (
    <div className="ApplyLoans">
      <RenderHome title="Apply Loan">
        {isLoading && <Loader />}

        <Loan_chip formState={formState} />

        <form onSubmit={(e) => e.preventDefault()} style={{ maxWidth: "800px", margin: "0 auto", padding: "0 1rem 2rem" }}>

          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Employment Details</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              {/* Employer is derived from the signed-in user's facility, so it
                  was a disabled <select> holding a single option — it looked
                  tappable but could never open. Shown read-only instead, to
                  match the Facility and Staff ID fields beside it. */}
              <Field label="Employer" required>
                <input type="text" name="employer_name" readOnly
                  value={employer_name || ""}
                  className={readonlyCls} placeholder="Your employer" />
              </Field>
              <Field label="Facility" required>
                <input type="text" name="facility" readOnly value={user?.facility || ""}
                  className={readonlyCls} placeholder="Your facility" />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Field label="Staff ID" required>
                <input type="text" name="staff_id" readOnly value={user?.staff_id || ""}
                  className={readonlyCls} placeholder="Your staff ID" />
              </Field>
              <Field label="Employment Start Date" required error={formError.employment_start_date}>
                <input type="date" name="employment_start_date"
                  value={formData.employment_start_date ?? ""}
                  onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>
          </div>

          <div className="flex justify-between mt-2">
            <button type="button"
              onClick={() => history.push("/apply-loan-guarantor")}
              className="px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none">
              Back
            </button>
            <button type="button" onClick={handleFormSubmitHandler}
              className="px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none">
              Save and continue
            </button>
          </div>

        </form>
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default Employment;
